module.exports = "<div class=\"divider-group q-pad-vert q-pad-horz\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-boldest> Product SKU: </div> </div> <div class=\"col-md-6 col-xs-12\"> {%- productSku %} </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-boldest> Quantity Packed: </div> </div> <div class=\"col-md-6 col-xs-12\"> {%- quantityPacked %} </div> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/amazon/html/lpnSku.html
// module id = 279
// module chunks = 1